(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('card-prefix-config', {
            parent: 'entity',
            url: '/card-prefix-config?page&sort&search',
            data: {
                authorities: ['ROLE_USER', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.cardPrefixConfig.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-configs.html',
                    controller: 'CardPrefixConfigController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cardPrefixConfig');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('card-prefix-config-detail', {
            parent: 'card-prefix-config',
            url: '/card-prefix-config/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.cardPrefixConfig.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-detail.html',
                    controller: 'CardPrefixConfigDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cardPrefixConfig');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CardPrefixConfig', function($stateParams, CardPrefixConfig) {
                    return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'card-prefix-config',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('card-prefix-config-detail.edit', {
            parent: 'card-prefix-config-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER', 'ROLE_MANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-dialog.html',
                    controller: 'CardPrefixConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CardPrefixConfig', function(CardPrefixConfig) {
                            return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('card-prefix-config.new', {
            parent: 'card-prefix-config',
            url: '/new',
            data: {
                authorities: ['ROLE_USER', 'ROLE_MANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-dialog.html',
                    controller: 'CardPrefixConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                prefix: null,
                                cardType: null,
                                isActive: false,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('card-prefix-config', null, { reload: 'card-prefix-config' });
                }, function() {
                    $state.go('card-prefix-config');
                });
            }]
        })
        .state('card-prefix-config.edit', {
            parent: 'card-prefix-config',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-dialog.html',
                    controller: 'CardPrefixConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CardPrefixConfig', function(CardPrefixConfig) {
                            return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('card-prefix-config', null, { reload: 'card-prefix-config' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('card-prefix-config.delete', {
            parent: 'card-prefix-config',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-delete-dialog.html',
                    controller: 'CardPrefixConfigDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CardPrefixConfig', function(CardPrefixConfig) {
                            return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('card-prefix-config', null, { reload: 'card-prefix-config' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
